/**
* @module lib/appserver/aggregate
* Construct and deconstruct globbaly unique IDs for entities
*/

import { aggregateID, deconstructID } from "lib/id";

/**
 * @param {Object} entity
 * @param {string} entity.serverID
 * @param {string} entity.remoteSchoolID
 * @returns {string} schoolID (serverID + remoteSchoolID)
 * Get the aggregated schoolID for the given entity
 */
export function aggregateSchoolID({ serverID, remoteSchoolID }) {
  return aggregateID(serverID, remoteSchoolID);
}

/**
 * @param {string} schoolID
 * @returns {Object} { serverID, remoteSchoolID }
 * Get the serverID and remoteSchoolID from the given aggregated schoolID
 */
export function deconstructSchoolID(schoolID) {
  const [ serverID, remoteSchoolID ] = deconstructID(schoolID);
  return { serverID, remoteSchoolID };
}

/**
 * @param {Object} entity
 * @param {string} entity.serverID
 * @param {string} entity.remoteSchoolID
 * @returns {string} studentID (serverID + remoteStudentID)
 * Get the aggregated studentID for the given entity
 */
export function aggregateStudentID({ serverID, remoteStudentID }) {
  return aggregateID(serverID, remoteStudentID);
}

/**
 * @param {string} studentID
 * @returns {Object} { serverID, remoteStudentID }
 * Get the serverID and remoteStudentID from the given aggregated studentID
 */
export function deconstructStudentID(studentID) {
  const [ serverID, remoteStudentID ] = deconstructID(studentID);
  return { serverID, remoteStudentID };
}

/**
 * @param {Object} entity
 * @param {string} entity.serverID
 * @param {string} entity.remoteID
 * @returns {string} entityID
 * Get the aggregated ID for the given entity
 */
export function aggregateEntityID({ serverID, remoteID }) {
  return aggregateID(serverID, remoteID);
}

/**
 * @param {string} entityID
 * @returns {Object} { serverID, remoteID }
 * Get the serverID and remoteID from the given aggregated entityID
 */
export function deconstructEntityID(entityID) {
  const [ serverID, remoteID ] = deconstructID(entityID);
  return { serverID, remoteID };
}



// WEBPACK FOOTER //
// ./src/lib/appserver/aggregate.js